import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import dealerReducer from "./dealerSlice";
import territoryReducer from "./territorySlice";
import salesReducer from "./salesSlice";
import categoryReducer from "./categorySlice";
import productReducer from "./productSlice";
import campaignReducer from "./campaignSlice";
import distributorReducer from "./distributorSlice";
import salesDataReducer from "./salesDataSlice";
import stockReducer from "./stockSlice";
import paymentReducer from "./paymentSlice";
import dashboardReducer from "./dashboardSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dealer: dealerReducer,
    territory: territoryReducer,
    sales: salesReducer,
    category: categoryReducer,
    product: productReducer,
    campaign: campaignReducer,
    distributor: distributorReducer,
    salesData: salesDataReducer,
    stock: stockReducer,
    payment: paymentReducer,
    dashboard: dashboardReducer,
  },
});
